import { Box, Checkbox, Chip, Typography } from "@mui/material";

import { rowCenter, rowHorizontalCenter } from "../../../GlobalStyles";
import { arrowBottom, arrowTop } from "../../../assets/svgs";
import CustomIconButton from "../../CustomIconButton";
import globalColors from "../../../globalColors";
import { convertFirstUpper } from "../../../Regex";
export const singleLineEllipsis = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
};
function CardHeader({
  name,
  description,
  id,
  status,
  is_active,
  primary_language,
  onClick,
  onOpen,
  selected,
  checked,
}: {
  name: string;
  description: string;
  id: number;
  status: string;
  is_active: boolean;
  primary_language?: string;
  onClick?(data: any): void;
  selected: boolean;
  onOpen?: any;
  checked?: boolean;
}) {
  return (
    <Box display="flex" alignItems="center" flexDirection={"row"} gap="8px">
      {onClick ? (
        <Checkbox
          checked={checked}
          onClick={onClick}
          sx={{ height: "16px", width: "16px", color: "#d1d5db" }}
        />
      ) : (
        ""
      )}
      {onOpen !== undefined ? (
        <CustomIconButton
          content=""
          icon={selected ? arrowTop : arrowBottom}
          variant="text"
          onClick={onOpen}
          sx={{ p: "2px" }}
        />
      ) : (
        ""
      )}
      <Box display="flex" alignItems="start" flexDirection={"column"} gap="2px">
        <Box sx={{ ...rowCenter, gap: "8px" }}>
          <Typography
            variant="h6"
            fontWeight={600}
            noWrap
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "70%",
              color: "#374151",
              fontSize: "14px",
            }}
          >
            {name}{" "}
          </Typography>{" "}
          <Box
            sx={{ gap: "10px", overflow: "hidden", pt: "1px", display: "flex" }}
          >
            <Chip
              label={`ID: #${id}`}
              size="small"
              sx={{
                bgcolor: "#eef2ff",
                color: "#4338ca",
                ...singleLineEllipsis,
                borderRadius: "4px",
                padding: "2px 6px",
                "& .MuiChip-label": {
                  fontSize: "12px",
                  padding: "0",
                },
              }}
            />{" "}
            {status && (
              <Box
                sx={{
                  borderRadius: "4px",
                  padding: "6px 10px",
                  background: globalColors.colorCombinations[status]?.bg ?? "",
                  color: globalColors.colorCombinations[status]?.color ?? "",
                  textTransform: "capitalize",
                  ...rowHorizontalCenter,
                  ...singleLineEllipsis,
                  // minWidth: "fit-content",
                  maxWidth: "100%",
                  fontSize: "0.75rem",
                  lineHeight: "normal",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                  overflow: "hidden",
                  width: "fit-content",
                }}
              >
                {convertFirstUpper(status)}
              </Box>
              // <Chip
              //   label={status}
              //   size="small"
              //   color={is_active ? "success" : "default"}
              //   sx={{
              //     fontWeight: 500,
              //     textTransform: "capitalize",
              //     ...singleLineEllipsis,
              //     borderRadius: "4px",
              //     padding: "2px 6px",
              //     "& .MuiChip-label": {
              //       fontSize: "12px",
              //       padding: "0",
              //     },
              //   }}
              // />
            )}
          </Box>
        </Box>
        <Box sx={{ ...rowCenter, gap: "8px" }}>
          {description && (
            <Typography
              variant="body2"
              color="text.secondary"
              mb={"0"}
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                fontSize: "12px",
                color: "#6b7280",
              }}
            >
              {description}
            </Typography>
          )}
          {primary_language && (
            <Chip
              label={`Language : ${primary_language}`}
              size="small"
              sx={{
                bgcolor: "#fef3c7",
                color: "#92400e",
                ...singleLineEllipsis,
                borderRadius: "4px",
                padding: "2px 6px",
                "& .MuiChip-label": {
                  fontSize: "12px",
                  padding: "0",
                },
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default CardHeader;
